export default __webpack_public_path__ + "0b0348b.png";